import styled from 'styled-components'
import Image from '../../Image/Image'
import Link from '../../Link/Link'

export const StyledHeader = styled.div`
  width: 100vw;
  height: ${({ theme }) => theme.headerHeight};
  z-index: 999;
  position: fixed;
  width: 100%;
`

export const Float = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0px 30px;
  transition: all 0.5s ease-in-out;
  background-color: ${({ theme }) => theme.color.backgroundHeader};
`

export const LogoWrapper = styled.div`
  width: 25%;
`

export const ItemWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Item = styled.div`
  color: ${({ theme }) => theme.color.font.secondary};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: ${({ justify }) => justify || 'center'};

  &:hover {
    .popover {
      display: block !important;
    }
  }
  @media (max-width: ${({ theme }) => theme.breakpoint.lg}) {
    width: auto;
    display: ${({ mobileVisible }) => (mobileVisible ? 'block' : 'none')};
    text-align: right;
  }
`

export const StyledToggle = styled.img`
  height: 30px;
  cursor: pointer;
  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    height: 30px;
  }
`

export const Navigation = styled.div`
  background-color: ${({ theme }) => theme.color.backgroundDark};
  z-index: 998;
  position: absolute;
  width: 100vw;
  height: calc(100vh - 100px);
  top: 100px;
  left: 0px;
  padding: 30px;
`

export const CustomLink = styled(Link)`
  color: ${({ theme }) => theme.color.font.secondary};
  font-size: ${({ theme }) => theme.size.sm};
  ${({ highlight, theme }) =>
    highlight &&
    `
    color: ${theme.color.font.highlightOnDark};
    text-decoration: underline;
    `}
  ${({ button, theme }) =>
    button &&
    `
    border: 2px solid ${theme.color.border.light};
    border-radius: ${theme.border.radius};
    box-shadow: 0px 0px 10px -4px #ffffff;
    padding: 10px 10px 7px;
    @media (max-width: ${theme.breakpoint.md}) {
      text-align: center;
    }
    `}
  cursor: ${({ noClick }) => (noClick ? 'default' : 'pointer')};
`

export const Logo = styled(Image)`
  height: 40px;
  cursor: pointer;
  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    height: 30px;
  }
`

export const Icon = styled.img`
  height: 20px;
  display: flex;
`
